import { useLatestRef } from '@griply/hooks';
import { EventProps, WebTrackingEvent } from '@griply/types';
import { useCallback } from 'react';
import { getMixpanelService } from 'shared/services/tracking';

import { useUser } from './use-user';

export const useTrackEvents = () => {
  const user = useUser();
  const userRef = useLatestRef(user);

  return useCallback(
    <TrackEvent extends WebTrackingEvent>(
      event: TrackEvent,
      eventProps: EventProps<TrackEvent>,
    ) => {
      getMixpanelService(userRef.current).track(event, eventProps);
    },
    [userRef],
  );
};
